import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maskIfNotAdmin'
})
export class MaskIfNotAdminPipe implements PipeTransform {
    transform(value: string | String | null | undefined, isAdmin: boolean): string {
        console.log("admin" + isAdmin)
        const phone = value ? value.toString() : '';
        return isAdmin ? phone : '*'.repeat(phone.length);
    }
}